export default "__VITE_ASSET__C$g2JR9g__"